import { useEffect } from "react";
import { useCollection } from "@nandorojo/swr-firestore";
import { useAuth } from "../../../lib/use-auth";
import {
  Columns,
  Section,
  Message,
  Heading,
  Loader
} from "react-bulma-components";
import { COLORS } from "../../../constants";
import CompanyMenu from "../../../components/companies/CompanyMenu";
import groupBy from "lodash/groupBy";
import orderBy from "lodash/orderBy";
import Link from "next/link";
import { withAuthModal } from "../../../components/auth";

const ManageIndex = ({ openAuthModal }) => {
  const { user } = useAuth();
  const companiesData = useCollection(user ? "companies" : null, {
    where: [`admins.${user?.uid}`, "==", true]
  });
  const companies = orderBy(companiesData.data, ["name"], ["asc"]);
  // console.log(companies && companies.map(get("id")))
  const jobsData = useCollection(companies ? "jobs" : null, {
    where: ["company.id", "in", companies?.map(item => item.id)]
  });
  const jobs = jobsData.data;
  const byCompany = groupBy(jobs, item => item.company.id);

  useEffect(() => {
    if (!user) {
      openAuthModal();
    }
  }, [user]);

  if (!user) {
    return <Loader />;
  }

  return (
    <Section>
      <Columns>
        <Columns.Column size={2}>
          <CompanyMenu
            companies={companies}
            jobsByCompany={byCompany}
            selectedComp={null}
            selectedJob={null}
          />
        </Columns.Column>
        <Columns.Column size={10}>
          <Heading>Manage your jobs</Heading>
          <br />
          <br />
          <Columns>
            <Columns.Column size={4} offset={3}>
              <Message color={COLORS.LIGHT}>
                <Message.Body>
                  Select a company to view jobs
                  <br />
                  <br />
                  <Link href={`/companies/new`}>
                    <a>Create a new company</a>
                  </Link>
                </Message.Body>
              </Message>
            </Columns.Column>
          </Columns>
        </Columns.Column>
      </Columns>
    </Section>
  );
};

export default withAuthModal(ManageIndex);
